import CryptoJS from 'crypto-js';
// eslint-disable-next-line max-len
export const encrypt = stringValue => CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(stringValue));
// eslint-disable-next-line max-len
export const decrypt = encryptedValue => CryptoJS.enc.Base64.parse(encryptedValue).toString(CryptoJS.enc.Utf8);
